


const convertArrayToString = (array) => {
    return array.join(', ')
}


export { convertArrayToString }
